//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import numeric from "@/components/numeric";

export default {
  props: {
    article: {},
  },
  components: { numeric },
  data() {
    return {
      AccountTypes: [],
      AccountTypesPurchase: [],
      VatTypes: [],
      VatTypesPurchase: [],
      FilterAccountTypes: [],
      FilterAccountTypesPurchase: [],
      FilterVatTypes: [],
      FilterVatTypesPurchase: [],
      dense: true,
    };
  },

  computed: {
    ...mapState("main", ["vatTypes"]),
  },

  mounted: function() {
    this.initSelectBox();
  },

  methods: {
    ...mapActions("main", ["getVatType", "getAccount"]),

    async initSelectBox() {    
      this.AccountTypes = await this.getAccount();      
      this.FilterAccountTypes = this.FilterAccountTypesPurchase = this.AccountTypesPurchase = this.AccountTypes;

      this.VatTypes = this.vatTypes;
      if (!this.VatTypes) {
        this.VatTypes = await this.getVatType();
      }
      this.FilterVatTypes = this.VatTypesPurchase = this.FilterVatTypesPurchase = this.VatTypes;
    },

    getAccountTypesFilter(val, update) {
      if (!this.AccountTypes) {
        update();
        return;
      }
      update(() => {
        this.AccountTypes = this.FilterAccountTypes.filter(
          (v) =>
            v.accountName.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            v.accountNumber >= 3000 &&
            v.accountNumber < 4000 &&
            v.accountID == null
        );
      });
    },

    getAccountTypesFilterPurchase(val, update) {
      if (!this.AccountTypesPurchase) {
        update();
        return;
      }
      update(() => {
        this.AccountTypesPurchase = this.FilterAccountTypesPurchase.filter(
          (v) =>
            v.accountName.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            v.accountNumber >= 4000 &&
            v.accountNumber < 5000 &&
            v.accountID == null
        );
      });
    },

    getVatTypesFilter(val, update) {
      if (!this.VatTypes) {
        update();
        return;
      }
      update(() => {
        this.VatTypes = this.FilterVatTypes.filter(
          (v) =>
            v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            (v.vatCodeGroupID == 9 || v.vatCodeGroupID == 8)
        );
      });
    },

    getVatTypesFilterPurchase(val, update) {
      if (!this.VatTypes) {
        update();
        return;
      }
      update(() => {
        this.VatTypesPurchase = this.FilterVatTypesPurchase.filter(
          (v) =>
            v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            v.vatCodeGroupID == 13
        );
      });
    },

    setVatCode(value) {
      var selectedAccountType = this.AccountTypes.filter((v) => v.id == value);
      var selectedVatType = this.FilterVatTypes.filter((v) => v.id == selectedAccountType[0].vatTypeID);
      this.article.vatTypeId = selectedVatType[0].id;
    }, 

    setPurchaseVatCode(value) {
      var selectedPurchaseAccountType = this.AccountTypesPurchase.filter((v) => v.id == value);
      var selectedPurchaseVatType = this.FilterVatTypesPurchase.filter((v) => v.id == selectedPurchaseAccountType[0].vatTypeID);
      this.article.purchaseVatTypeId = selectedPurchaseVatType[0].id;
    },

  },
    watch: {  
    'article.mainComponent': function (newValue, oldValue){
      if (newValue != oldValue) {
        if (newValue === true) {      
          this.article.type = 0;          
        }         
        this.article.mainComponent = newValue;        
      }
    },
  },
};
